import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import errorImg from "../Assets/undraw_error.svg";
import Particle from "./Particle";

const ErrorPage = () => {
  return (
    <section style={{flex:1}}>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={6} className="home-header">
              <h1 className="heading-name">
                <strong className="main-name">Oops!</strong>
              </h1>
              <h1 className="heading-name">Sorry, Page <strong className="main-name">not</strong> found.</h1>
            </Col>
            <Col md={6} style={{ paddingBottom: 20 }}>
              <img src={errorImg} alt="error" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
};

export default ErrorPage;
